// Entry de /proyectos/: conversión + filtro de galería por categoría (sin 3D).
import { initReveals } from './ui/reveals'
import { initConversion } from './ui/conversion'
import { initCalModal } from './ui/calmodal'
import { initMenu } from './ui/menu'
import { captureGclid } from './analytics/gclid'

document.documentElement.classList.add('js')

captureGclid()
initReveals()
initConversion()
initMenu()
initCalModal()
initFilter()

function initFilter(): void {
  const btns = Array.from(document.querySelectorAll<HTMLButtonElement>('.gfilter__btn'))
  const cards = Array.from(document.querySelectorAll<HTMLElement>('#proy-grid [data-cat]'))
  const empty = document.getElementById('proy-empty')
  if (!btns.length || !cards.length) return

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const f = btn.dataset.filter || 'all'
      btns.forEach((x) => {
        const on = x === btn
        x.classList.toggle('is-active', on)
        x.setAttribute('aria-pressed', String(on))
      })
      let visible = 0
      cards.forEach((c) => {
        const show = f === 'all' || c.dataset.cat === f
        c.style.display = show ? '' : 'none'
        if (show) visible++
      })
      if (empty) empty.hidden = visible !== 0
    })
  })
}
